import { getName } from 'i18n-iso-countries';

export function getCountryName(countryCode: string, { locale = 'en' } = {}) {
  return getName(countryCode, locale) ?? countryCode;
}
